import { PublicButtonPropsWithType } from 'shared/utils'
import useStyleMaps from 'site/Renderer/hooks/useStyleMap'
import { SafeHtmlContent } from 'site/shared/components/SafeHtmlContent'
import SupportBanner from './SupportBanner'
import {
  SupportBannerContainerProps,
  SupportBannerProps
} from './SupportBannerContainer.types'

const SupportBannerContainer = ({ props }: SupportBannerContainerProps) => {
  const styleProps = useStyleMaps(props.styleMap)
  const buttonProps = props?.buttonProps as SupportBannerProps['button']
  const button = {
    label: props.buttonLabel ?? buttonProps?.label,
    href:
      props.buttonHref ??
      (buttonProps as PublicButtonPropsWithType)?.link?.url ??
      buttonProps?.href,
    style: props.buttonStyle ?? buttonProps?.style,
    ...(buttonProps ?? {})
  }
  return (
    <SupportBanner
      des={<SafeHtmlContent html={props.des} />}
      button={button}
      leftBackgroundImageUrl={props.leftBackgroundImageUrl}
      rightBackgroundImageUrl={props.rightBackgroundImageUrl}
      style={styleProps}
    />
  )
}

export default SupportBannerContainer
